<template>
  <AccountOpePanel class="aiz-user-panel">
    <div class="aiz-titlebar mt-2 mb-4">
      <div class="row align-items-center">
        <div class="col-md-6">
          <b class="h4">{{ $t("对话") }}</b>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <ul class="list-group list-group-flush">
          <li
              class="list-group-item px-0"
              @click="
              jump(
                `/user/conversation_detail?` +
                  `groupId=${item.id}`
              )
            "
              v-for="item in list"
              :key="item.id"
          >
            <el-badge class="badgeLeft" :is-dot="false" style="display: initial;"
                      :value="item.unReadNum?item.unReadNum:null">
              <div class="row gutters-10">
                <div class="col-auto">
                  <div class="media">
                  <span class="avatar avatar-sm flex-shrink-0">
                    <img :src="getFileViewUrl(item.photo)"/>
                  </span>
                  </div>
                </div>
                <div class="col-auto col-lg-3">
                  <p>
                    <span class="fw-600">{{ item.name }}</span>
                    <br/>
                    <span class="opacity-50">
                    {{ item.lastMessageTime }}
                  </span>
                  </p>
                </div>
                <div class="col-12 col-lg">
                  <div class="block-body">
                    <div class="block-body-inner pb-3">
                      <div class="row no-gutters">
                        <div class="col">
                          <h6 class="mt-0">
                            <a href="javascript:void(0)" class="text-dark fw-600">
                              {{ item.no }}
                            </a>
                          </h6>
                        </div>
                      </div>
                      <p class="mb-0 opacity-50">
                        <div v-if="item.msgType ==='image'">[{{$t('图片')}}]</div>
                        <div v-else-if="item.msgType ==='url'">[{{$t('链接')}}]</div>
                        <div v-else>{{ item.lastMessage }}</div>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-badge>
          </li>
        </ul>
        <el-empty
            :description="$t('暂时没有对话')"
            v-if="!list || list.length === 0"
        />
      </div>
    </div>
    <div class="aiz-pagination"></div>
  </AccountOpePanel>
</template>
<script>
import AccountOpePanel from "@/components/AccountOpePanel.vue";

export default {
  components: {
    AccountOpePanel
  },
  data() {
    return {list: []};
  },
  computed: {
    ...Vuex.mapGetters([
      "userInfo",
      'chatUnread',
      'chatGroupLastChange',
      'chatGroupRecord',
    ])
  },
  watch: {
    chatGroupLastChange: {
      handler(newVal, oldVal) {
        this.list.forEach(o => {
          if (parseInt(o.id) === parseInt(newVal.id)) {
            for (let key of Object.keys(newVal)) {
              this.$set(o,key,newVal[key])
            }
            let item = o
            item.lastMessage = JSON.parse(item.lastMessageSimpleJson).content;
          }
        })
      },
      deep: true
    },
  },
  async created() {
    const params = {};
    const res = await this.$get("/user/chatGroup/page", {params});
    console.log("/user/chatGroup/page", res);
    this.list = res.data.records.map(item => {
      const memberOther = item.chatGroup_chatGroupMember.find(
          member => member.userId !== this.userInfo.id
      );
      item.shopUserId = memberOther.userId;
      item.photo = memberOther.pic;
      item.name = memberOther.nickName;
      item.lastMessage = JSON.parse(item.lastMessageSimpleJson).content;
      item.msgType = JSON.parse(item.lastMessageSimpleJson).type;

      const memberSelf = item.chatGroup_chatGroupMember.find(
          member => member.userId === this.userInfo.id
      );
      item.unReadNum = memberSelf.unReadNum;

      return item;
    });
  }
};
</script>
